import { render, staticRenderFns } from "./21.vue?vue&type=template&id=53cb1b66"
import script from "./21.vue?vue&type=script&lang=js"
export * from "./21.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports